import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    NavigationExtras,
    CanLoad, Route
} from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { AUTH_CONSTANTS } from './auth-constants';
const _ = require('lodash');

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

        const url: string = state.url;
        if (this.canUserAccess(url)) {
            if (this.canEnterpriseAdminAccess(url)) {
                return this.checkLogin(url);
            } else {
                console.log('cannot canactivate:' + url);
            }
        }

        console.log('cannot canactivate:' + url);
        return false;
    }

    public canLoad(route: Route): Observable<boolean> | boolean {
        const url = `/${route.path}`;
        return this.checkLogin(url);
    }

    public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.canActivate(route, state);
    }

    public checkLogin(url: string): Observable<boolean> | boolean {

        if (this.authService.isLoggedIn) {
            return true;
        }
        this.authService.redirectUrl = url;
        return this.authService.cookieBasedLogin().map(() => {
            if (this.authService.isLoggedIn) {
                return true;
            } else {
                console.log('not logged in checkLogin navigate ot /login:' + url);
                this.router.navigate(['/login']);
                return false;
            }
        });
    }

    public canEnterpriseAdminAccess(url) {
        // Block access to certain routes for which Enterprise admin doesn;t have permission. Works only for VC Cloud.
        // Bug 2088858
        if (this.authService &&
            this.authService.VREALM_TYPE &&
            (this.authService.VREALM_TYPE === AUTH_CONSTANTS.VC || this.authService.VREALM_TYPE === AUTH_CONSTANTS.VCD)
            ) {

            const roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];

            if (_.includes(roles, 'System Administrator')) {
                return true;
            }

            const urlList = [
                '/services/networking/network/import',
                '/services/networking/gateways/import'
            ];

            if (urlList.indexOf(url) >= 0) {
                return false;
            }
        }
        return true;
    }

    public canUserAccess(url: string) {
        // Block access to dashboard, inventory and certain services(compute, gateway and DPS) when NSP is using new GVR.
        // Happens in case of only VCD.

        // limited UI for VCD based cloud
        if (this.authService.VREALM_TYPE === AUTH_CONSTANTS.VCD && this.authService.isVCDGVRDepricated) {
            return (url.indexOf('/administration') !== -1 || '/disaster-recovery-embed' === url || '/network-extension-embed' === url  || url.indexOf('/fleet') !== -1 || '/connectivity-health' === url);
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.guard.ts